module.exports = __webpack_public_path__ + "static/media/paserg-bsa-logo.c86cb47c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/paserg/paserg-bsa-logo.png
// module id = 217
// module chunks = 0